import React from 'react';
export function useChip({ onInitialChipLabel, field, chipLabel }) {
    const [initialRender, setInitialRender] = React.useState(true);
    React.useEffect(() => {
        if (initialRender) {
            if (field && chipLabel && onInitialChipLabel) {
                onInitialChipLabel(field, chipLabel);
            }
            setInitialRender(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
